import { render, staticRenderFns } from "./ItemUserSend.vue?vue&type=template&id=bc9d6dfa"
import script from "./ItemUserSend.vue?vue&type=script&lang=js"
export * from "./ItemUserSend.vue?vue&type=script&lang=js"
import style0 from "./ItemUserSend.vue?vue&type=style&index=0&id=bc9d6dfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports